module.exports = __webpack_public_path__ + "img/icon_face.fe261bb4.png";